module.exports = __webpack_public_path__ + "assets/img/offline.e5f9763d.png";